// Map of route pathPattern (as declared in navigation.router.tsx) to the
// Amplitude event name emitted when the user navigates to that page.
// Order matters: matchPath is iterated in declaration order — list more
// specific patterns first if any prefix overlap is ever introduced.
export const ROUTE_EVENTS: Record<string, string> = {
  // Auth (anonymous events — useful for funnel analysis)
  '/auth/login': 'LoginPageViewed',
  '/auth/register/:token': 'RegisterPageViewed',
  '/auth/password-forgot': 'PasswordForgotPageViewed',
  '/auth/reset-password/:token': 'ResetPasswordPageViewed',

  // Network-level pages (listed before /clients/:clientId/* to avoid any
  // future ambiguity if a sibling pattern is added)
  '/clients/:clientId/network/:networkId/dashboard':
    'ProjectDashboardPageViewed',
  '/clients/:clientId/network/:networkId/work': 'ProjectWorkPageViewed',
  '/clients/:clientId/network/:networkId/synoptic': 'ProjectSynopticPageViewed',
  '/clients/:clientId/network/:networkId/activities':
    'ProjectActivitiesListPageViewed',
  '/clients/:clientId/network/:networkId/notices':
    'ProjectNoticesListPageViewed',
  '/clients/:clientId/network/:networkId/reports': 'ProjectReportsPageViewed',
  '/clients/:clientId/network/:networkId/protections':
    'ProjectProtectionsListPageViewed',
  '/clients/:clientId/network/:networkId/settings': 'ProjectSettingsPageViewed',
  // One event for every section: `path` tells them apart, and shows whether
  // client-wide settings get reached from the project rather than the client.
  '/clients/:clientId/network/:networkId/settings/:section':
    'ProjectSettingsPageViewed',

  // Client-level pages
  '/clients/:clientId/projects': 'ClientProjectsPageViewed',

  // Home
  '/': 'ClientListPageViewed',
}
